import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from "../../../../hooks";
import { LOCALES } from "../../../../locales";
import { StyledContainer, StyledTitle, StyledDesc, StyledBenefitList, StyledBenefitItem, StyledCurveWrapper, StyledCurveTitle, StyledCurveChart } from "./styled";
import IconCheck from "../../../../assets/images/check-outlined.svg";
import CurveChartZH from "../../../../assets/images/best-buy-curve-chart-zh.png";
import CurveChartEN from "../../../../assets/images/best-buy-curve-chart-en.png";
import dynamic from 'next/dynamic';
var SwapPriceChart = dynamic(() => import("../../../charts/SwapPriceChart"), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [require.resolveWeak("../../../charts/SwapPriceChart")]
  }
});
var MiniSwapPriceChart = dynamic(() => import("../../../charts/MiniSwapPriceChart"), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [require.resolveWeak("../../../charts/MiniSwapPriceChart")]
  }
});

var OnboardingChartBox = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useBreakpoint = useBreakpoint(),
      isMobile = _useBreakpoint.isMobile;

  var _useState = useState(false),
      miniChartVisible = _useState[0],
      setMiniChartVisible = _useState[1];

  var benefits = [t('best_buy_benefit_1'), t('best_buy_benefit_2'), t('best_buy_benefit_3'), t('best_buy_benefit_4')];
  var isZh = i18n.resolvedLanguage === LOCALES.ZH;
  var CurveChart = isZh ? CurveChartZH : CurveChartEN;

  var handleChartExpand = () => {
    setMiniChartVisible(!miniChartVisible);
  };

  useEffect(() => {
    if (isMobile) return setMiniChartVisible(true);
  }, []);
  return __jsx(StyledContainer, null, __jsx("div", null, __jsx(StyledTitle, null, t('best_buy_onboarding_chart_title')), __jsx(StyledDesc, null, t('best_buy_onboarding_chart_desc')), __jsx(StyledBenefitList, null, benefits.map((benefit, index) => {
    return __jsx(StyledBenefitItem, {
      key: index
    }, __jsx("img", {
      src: IconCheck
    }), __jsx("span", null, benefit));
  }))), miniChartVisible ? __jsx(MiniSwapPriceChart, {
    handleChartExpand: handleChartExpand
  }) : __jsx(SwapPriceChart, {
    handleChartExpand: handleChartExpand
  }), !isMobile && __jsx(StyledCurveWrapper, null, __jsx(StyledCurveTitle, null, t('best_buy_curve_chart_title')), __jsx(StyledCurveChart, {
    src: CurveChart.src,
    alt: "BestBuy curve"
  })));
};

export default OnboardingChartBox;